function wm_init_accordions() {
    let accordions = document.querySelectorAll('[data-accordion-toggle]');

    if (!accordions.length) {
        return;
    }

    accordions.forEach(el => {
        el.addEventListener('click', function() {
            let parent = this.closest('[data-accordion-parent]');
            parent.classList.toggle('is-active');

            let siblings = Array.from(parent.parentNode.children);
            siblings = siblings.filter(item => item !== parent);

            siblings.forEach(sibling => {
                sibling.classList.remove('is-active');
            });

            if (this.dataset.accordionToggle == 'caption') {
                this.textContent = parent.classList.contains('is-active') ? wm_vars.caption_less : wm_vars.caption_more;
            }

            return false;
        });
    });
}

wm_init_accordions();

function wm_init_menu_accordions() {
    let accordion_menus = document.querySelectorAll('.accordion-menu .menu-item-has-children');

    if (!accordion_menus.length) {
        return;
    }

    accordion_menus.forEach(el => {
        el.addEventListener('click', function() {
            let parent = this.closest('.menu-item-has-children');
            parent.classList.toggle('is-active');

            return false;
        });
    });
}

wm_init_menu_accordions();

function wm_init_hidden_accordions() {
    let toggle = document.querySelector('[data-product-amount]');

    if (!toggle) {
        return;
    }

    toggle.addEventListener('change', function(event) {
        let accordions = document.querySelectorAll('[data-accordion-min]');
        let cur = parseInt(event.target.value);

        if (!accordions.length) {
            return;
        }

        accordions.forEach(el => {
            let min = parseInt(el.dataset.accordionMin);
            let max = parseInt(el.dataset.accordionMax);
            let hidden = false;

            if (!isNaN(min)) {
                if (cur < min) {
                    hidden = true;
                }
            }

            if (!isNaN(max)) {
                if (cur >= max) {
                    hidden = true;
                }
            }

            el.classList.toggle('hide', hidden);
        });
    });
}

wm_init_hidden_accordions();
